import { DynamicColumn, ForeignKeyField, ObjectField } from "lego-gui-lib";
import {
  EnumField,
  RemoteDataSource,
  Required,
  Schema,
  TextField,
  Type
} from "lego-gui-lib/lib";
import { ReportDefinitionValidator } from "../../common/common";
import { t } from "../../core/i18n/i18n";
import { api, mainStore } from "../../core/mainStore";
import { Auth } from "../../core/model/auth";

export const IncludedEnum = [
  {
    label: t("hns:reportDefinition:included"),
    value: true
  },
  { label: t("hns:reportDefinition:not_included"), value: false }
];

export const ReportDetailsDefinitionSchema = (
  parentName: string,
  fieldType: Type
): Schema<DynamicColumn> =>
  new Schema<DynamicColumn>({
    fields: [
      {
        title: t("hns:reportDefinition:calls_total"),
        name: parentName + "callsTotal",
        type: fieldType,
        filter: false,
        sort: false
      },
      {
        title: t("hns:reportDefinition:avg_call_duration"),
        name: parentName + "avgCallDuration",
        type: fieldType,
        filter: false,
        sort: false
      },
      {
        title: t("hns:reportDefinition:total_call_duration"),
        name: parentName + "totalCallDuration",
        type: fieldType,
        filter: false,
        sort: false
      },
      {
        title: t("hns:reportDefinition:calls_answered"),
        name: parentName + "callsAnswered",
        type: fieldType,
        filter: false,
        sort: false
      },
      {
        title: t("hns:reportDefinition:calls_busy"),
        name: parentName + "callsBusy",
        type: fieldType,
        filter: false,
        sort: false
      },
      {
        title: t("hns:reportDefinition:calls_no_answer"),
        name: parentName + "callsNoAnswer",
        type: fieldType,
        filter: false,
        sort: false
      },
      {
        title: t("hns:reportDefinition:calls_ringing"),
        name: parentName + "callsRinging",
        type: fieldType,
        filter: false,
        sort: false
      },
      {
        title: t("hns:reportDefinition:calls_other_reason"),
        name: parentName + "callsOtherReason",
        type: fieldType,
        filter: false,
        sort: false
      },
      {
        title: t("hns:reportDefinition:queued_calls_total"),
        name: parentName + "queuedCallsTotal",
        type: fieldType,
        filter: false,
        sort: false
      },
      {
        title: t("hns:reportDefinition:queued_calls_percentage"),
        name: parentName + "queuedCallsPercentage",
        type: fieldType,
        filter: false,
        sort: false
      },
      {
        title: t("hns:reportDefinition:avg_time_in_queue"),
        name: parentName + "avgTimeInQueue",
        type: fieldType,
        filter: false,
        sort: false
      }
    ],
    primaryKey: ["name"],
    security: { readableRole: "ADMIN", editableRole: "ADMIN" }
  });

export const ReportDefinitionSchema = new Schema<DynamicColumn>({
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ADMIN,
    editableRole: Auth.Roles.ADMIN
  },
  fields: [
    {
      name: "name",
      type: TextField(Required),
      title: t("common:name")
    },
    {
      name: "definition",
      type: () =>
        ObjectField(
          ReportDetailsDefinitionSchema(
            "definition.",
            EnumField(IncludedEnum, ReportDefinitionValidator, Required)
          )
        ),
      title: t("common:definition")
    }
  ]
});

export const ReportDefinitionColumns = ReportDefinitionSchema.extend({
  definition: false
});

mainStore.reportDefinition = RemoteDataSource.create({
  api: api,
  name: "reportDefinition",
  schema: ReportDefinitionSchema,
  url: "/reportDefinitions",
  commons: mainStore.commons
});

mainStore.reportDefinitionFk = RemoteDataSource.clone(
  mainStore.reportDefinition
);

export const ReportDefinitionFK = ForeignKeyField(
  {
    dataSource: mainStore.reportDefinitionFk.listDataSource,
    labelField: "name",
    valueField: "id"
  },
  Required
);
